<template>
  <!-- prettier-ignore -->
  <ovp-modal
    v-model="show"
    locked
  >
    <div class="confirmation">
      <ovp-message
        class="confirmation__message"
        :text="label"
        :title="title"
        :severity="severity"
      />
      <div class="confirmation__actions">
        <ovp-button
          secondary
          @click="cancel"
          v-text="cancelText"
        />

        <ovp-button
          primary
          @click="confirm"
          v-text="confirmText"
        >
        </ovp-button>
      </div>
    </div>
  </ovp-modal>
</template>

<script>
import OvpMessage from '@/components/Container/Message'
import OvpModal from '@/components/Modal/Modal'
import { EVENT_CONFIRMATION_MODAL_OPEN } from '@/config/events'

export default {
  name: 'OvpConfirmation',

  components: {
    OvpModal,
    OvpMessage,
  },

  data() {
    return {
      show: false,
      label: null,
      title: null,
      severity: null,
      cancelText: null,
      confirmText: null,
      resolve: null,
      reject: null,
    }
  },

  created() {
    this.$EventBus.$on(EVENT_CONFIRMATION_MODAL_OPEN, this.handleBeforeOpenEvent)
  },

  beforeDestroy() {
    this.$EventBus.$off(EVENT_CONFIRMATION_MODAL_OPEN, this.handleBeforeOpenEvent)
  },

  methods: {
    handleBeforeOpenEvent(payload) {
      const { label, buttonLabels, title, severity, resolve, reject } = payload

      this.cancelText = buttonLabels?.cancelText || this.$t('form.cancel')
      this.confirmText = buttonLabels?.confirmText || this.$t('form.ok')

      this.label = label
      this.title = title
      this.severity = severity
      this.resolve = resolve
      this.reject = reject
      this.show = true
    },

    close() {
      this.show = false
      return Promise.resolve()
    },

    cancel() {
      this.close().then(_ => this.reject())
    },

    confirm() {
      this.close().then(_ => this.resolve())
    },
  },
}
</script>

<style name="mobile" scoped>
.confirmation__message {
  padding: 20px;
}

.confirmation__actions {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 30px 20px;
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .confirmation__message {
    padding: 30px;
  }

  .confirmation__actions {
    flex-direction: row;
    margin: 20px;
  }
}
</style>
